enum Types {
  REGISTER_ROLE_REQUEST = 'REGISTER_ROLE_REQUEST',
  REGISTER_ROLE_FULFILLED = 'REGISTER_ROLE_FULFILLED',
  REGISTER_ROLE_REJECTED = 'REGISTER_ROLE_REJECTED',

  EDIT_ROLE_REQUEST = 'EDIT_ROLE_REQUEST',
  EDIT_ROLE_FULFILLED = 'EDIT_ROLE_FULFILLED',
  EDIT_ROLE_REJECTED = 'EDIT_ROLE_REJECTED',

  GET_ALL_ROLES_REQUEST = 'GET_ALL_ROLES_REQUEST',
  GET_ALL_ROLES_FULFILLED = 'GET_ALL_ROLES_FULFILLED',
  GET_ALL_ROLES_REJECTED = 'GET_ALL_ROLES_REJECTED',

  REMOVE_ROLES_REQUEST = 'REMOVE_ROLES_REQUEST',
  REMOVE_ROLES_FULFILLED = 'REMOVE_ROLES_FULFILLED',
  REMOVE_ROLES_REJECTED = 'REMOVE_ROLES_REJECTED',

  GET_ROLE_INFO_REQUEST = 'GET_ROLE_INFO_REQUEST',
  GET_ROLE_INFO_FULFILLED = 'GET_ROLE_INFO_FULFILLED',
  GET_ROLE_INFO_REJECTED = 'GET_ROLE_INFO_REJECTED',

  GET_ALL_OBJECTS_REQUEST = 'GET_ALL_OBJECTS_REQUEST',
  GET_ALL_OBJECTS_FULFILLED = 'GET_ALL_OBJECTS_FULFILLED',
  GET_ALL_OBJECTS_REJECTED = 'GET_ALL_OBJECTS_REJECTED',

  GET_OBJECTS_REQUEST = 'GET_OBJECTS_REQUEST',
  GET_OBJECTS_FULFILLED = 'GET_OBJECTS_FULFILLED',
  GET_OBJECTS_REJECTED = 'GET_OBJECTS_REJECTED',

  GET_OBJECTS_AVAILABLE_REQUEST = 'GET_OBJECTS_AVAILABLE_REQUEST',
  GET_OBJECTS_AVAILABLE_FULFILLED = 'GET_OBJECTS_AVAILABLE_FULFILLED',
  GET_OBJECTS_AVAILABLE_REJECTED = 'GET_OBJECTS_AVAILABLE_REJECTED',

  REGISTER_OBJECTS_REQUEST = 'REGISTER_OBJECTS_REQUEST',
  REGISTER_OBJECTS_FULFILLED = 'REGISTER_OBJECTS_FULFILLED',
  REGISTER_OBJECTS_REJECTED = 'REGISTER_OBJECTS_REJECTED',

  REMOVE_OBJECTS_REQUEST = 'REMOVE_OBJECTS_REQUEST',
  REMOVE_OBJECTS_FULFILLED = 'REMOVE_OBJECTS_FULFILLED',
  REMOVE_OBJECTS_REJECTED = 'REMOVE_OBJECTS_REJECTED',

  GET_PERMISSIONS_REQUEST = 'GET_PERMISSIONS_REQUEST',
  GET_PERMISSIONS_FULFILLED = 'GET_PERMISSIONS_FULFILLED',
  GET_PERMISSIONS_REJECTED = 'GET_PERMISSIONS_REJECTED',

  REGISTER_PERMISSIONS_REQUEST = 'REGISTER_PERMISSIONS_REQUEST',
  REGISTER_PERMISSIONS_FULFILLED = 'REGISTER_PERMISSIONS_FULFILLED',
  REGISTER_PERMISSIONS_REJECTED = 'REGISTER_PERMISSIONS_REJECTED',

  TOGGLE_ADD_ALL_OBJECTS_REQUEST = 'TOGGLE_ADD_ALL_OBJECTS_REQUEST',
  TOGGLE_ADD_ALL_OBJECTS_FULFILLED = 'TOGGLE_ADD_ALL_OBJECTS_FULFILLED',
  TOGGLE_ADD_ALL_OBJECTS_REJECTED = 'TOGGLE_ADD_ALL_OBJECTS_REJECTED',

  CLONE_ROLE_REQUEST = 'CLONE_ROLE_REQUEST',
  CLONE_ROLE_FULFILLED = 'CLONE_ROLE_FULFILLED',
  CLONE_ROLE_REJECTED = 'CLONE_ROLE_REJECTED',

  RESET_GROUPS_SEARCH = 'RESET_GROUPS_SEARCH',
}

export default Types;
